import type { PlatformId, SiteId } from 'frontend-platform_detection';
import { Contextual } from '../../services/types';

const regiLightEnabledPlatforms: PlatformId[] = ['ML', 'PI', 'TC', 'MT'];
const regiLightEnabledSites: SiteId[] = ['MLM', 'MLB', 'MLA', 'MLU', 'MLC', 'MCO', 'MLV'];
const regiLightNotEnabledContextuals: Contextual[] = ['logistics', 'flex'];

export const isRegiLight = (
  platformId: PlatformId,
  siteId: SiteId,
  contextual?: Contextual,
// eslint-disable-next-line max-len
): boolean => regiLightEnabledPlatforms.includes(platformId) && regiLightEnabledSites.includes(siteId) && !regiLightNotEnabledContextuals.includes(contextual!);
